import { ensureString } from 'ensure-string';

export function parseRes(res) {
  res = ensureString(res);

  let meta = {};
  let currentMeta;
  for (let line of res.split(/\r?\n/).filter((line) => line)) {
    if (line.startsWith('[')) {
      currentMeta = {};
      meta[line.replace(/\[(.*)\]/, '$1')] = currentMeta;
    } else {
      const { field, value } = line.match(/(?<field>.*?)=(?<value>.*)/).groups;

      currentMeta[field] = isNaN(value) ? value : parseFloat(value);
    }
  }
  return meta;
}
